module.exports = __webpack_public_path__ + "img/9791190105002.4325fbcc.jpg";